import { makeStyles,withStyles,createStyles } from "@material-ui/core/styles";
import { Chip } from "@material-ui/core";
export const BillingStyles = makeStyles(theme => ({
  centerTitle: {
    display:"flex" ,
    justifyContent:"center",
    textAlign:"center"
  },
  linkpay: {
    color: theme.palette.ePrimary?.base,
    marginLeft: "10px",
   "&:hover":{
      color: theme.palette.ePrimary?.hover,
    }
  },
  linkFaq: {
    color: theme.palette.ePrimary?.base,
  },
  forthButton:{
    color: theme.palette.eWhite?.base,
    backgroundColor:theme.palette.ePrimary?.base
  },
  tableHead:{
    lineHeight: "1rem",
    padding: "5px"
  }
}));
 

export const cssuseStyles = makeStyles((theme) =>
  createStyles({
    backgroundCard: {
      backgroundColor: theme.palette.eLight?.base,
      borderRadius: "12px !important",
      height:"100%",
      boxShadow:"0px 0px 0px !important"
    },
    textFieldWidth: {
      paddingBottom: "6px",
      paddingTop: "6px",
      fontSize: "small"
    },
    warningCancelButtonStyling: {
      fontSize: "10px",
      color: theme.palette.ePrimary?.base,
    },
    warningSaveButtonStyling: {
      background: theme.palette.ePrimary?.base,
      color: theme.palette.whiteColor.main,
      fontSize: "10px",
      borderRadius: "16px",
      '&:hover': {
        backgroundColor: theme.palette.ePrimary?.hover,
        boxShadow: 'none',
      },
    },
    dailogTitle: {
      fontSize: "12px",
      background: theme.palette.ePrimary?.base,
      color: theme.palette.whiteColor.main,
      padding: "0px",
      marginLeft: "5px"
    },
    saveButtonStyling: {
      color: theme.palette.whiteColor.main + " !important",
      background: theme.palette.ePrimary?.base,
      borderRadius: "16px",
      fontSize: "11px",
      height: 30,
      '&:hover': {
        backgroundColor: theme.palette.ePastelColor2?.base,
        boxShadow: 'none',
      },
    },
    cancelButtonStyling: {
      color: theme.palette.ePrimary?.base,
      fontSize: "12px",
      "&:hover":{
        textDecoration: "underline",
      cursor: "pointer"
      },
      textTransform: 'none'
      
    },
    disabledSaveButton: {
      borderRadius: "16px",
      fontSize: "11px",
      height: 30
    },
    whiteButtonColor: {
      color: theme.palette.eWhite?.base + " !important",
    },
    marginTop: {
      marginTop: "5px",
    },
    marginBottom: {
      marginTop:"auto !important", 
    },
    fullHeight:{
      height: "100%"
    },
    textField: {
      margin: "0px",
      width: "150px",
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: "0px",
      },
      "& .MuiFormControl-marginNormal": {
        margin: "0px",
      },
      "& .MuiSvgIcon-root":{
        fontSize:"1.2rem"
      },
      "& .MuiInputBase-input":{
        fontSize:"14px"
      }
    },
    dateFields: {
      justifyContent: "space-around",
      marginBottom: "15px",
    },
    downloadButton: {
      margin: "auto",
      textAlign: "center"
    },
    dateRange:{
      paddingTop:"0px !important"
    },
    errorMessage:{
      color:"red",
      display:"block",
      fontSize:"0.75rem",
      marginBottom:"5px"
    },
    removePadding:{
        paddingBottom:"10px !important"
    },
    paymenttitle: {
      color: theme.palette.ePrimary?.base + " !important",
      ['@media (max-width:600px)']: {
          "& .MuiTypography-body1  ":{
            fontSize:"0.85rem !important"
          }
          }
  },
  mobileborder:{
    "& .MuiTypography-body1":{
        fontSize:"0.75rem",
        borderTop:"0px solid" + theme.palette.eLight?.base,
        borderBottom:"1px solid" + theme.palette.eLight?.base
      }
},
fontcell:{
  fontSize:".75rem",
  paddingLeft:"3%"
},
fontContent: {
  fontSize:".75rem"
},
tableHead:{
  minWidth: 130,
  lineHeight: "0 !important",
  padding: "10px ",
  "& .MuiSvgIcon-root":{
    fontSize:"1.2rem"
  }
},
paddingrow:{
  "& .MuiTableCell-root":{
      padding:"5px 8px ",
      fontSize:".75rem"
  }
},
    marginTopAuto:{
      display:"flex",
      flexDirection: "column",
      gap:"16px",
      height:"100%"
    },asterisk:{
      color: theme.palette.eDanger?.dark,
    }
  })
);
